import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type DeliveryWithinState = string;

export const DELIVERY_WITHIN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DeliveryWithinState>>,
): ConditionType<DeliveryWithinState, Condition.ShippingWithin> => ({
  name: "Time since delivery",
  description(state) {
    return `Within ${state} days of delivery`;
  },
  Details(props: ConditionTypeDetailsProps<DeliveryWithinState>) {
    return React.createElement(Details, props);
  },
  empty: String(30),
  fromModel(model) {
    return String(model.duration.total("days"));
  },
  toModel(state) {
    return {
      type: Condition.DELIVERY_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return +state >= 0;
  },
});
